// Signed minutes ↔ "h:mm" (overtime balances may be negative).
export function formatHm(minutes) {
  if (minutes === null || minutes === undefined) return ''
  const abs = Math.abs(minutes)
  return `${minutes < 0 ? '-' : ''}${Math.floor(abs / 60)}:${String(abs % 60).padStart(2, '0')}`
}

// '' → null, '37:41' → 2261, '-3:15' → -195, '12' → 720; NaN when not h:mm.
export function parseHm(text) {
  const value = String(text || '').trim()
  if (!value) return null
  const match = /^(-?)(\d+)(?::([0-5]\d))?$/.exec(value)
  if (!match) return NaN
  const minutes = Number(match[2]) * 60 + Number(match[3] || 0)
  return match[1] ? -minutes : minutes
}
